import * as ActionTypes from "./actionTypes";

export function createItem(values, path, successCallback, errorCallback, submitHandler, showLoader = true) {
	return { type: ActionTypes.CREATE_ITEM, values, path, successCallback, errorCallback, submitHandler, showLoader };
}
export function updateItem(values, path, successCallback, errorCallback, submitHandler, showLoader = true) {
	return { type: ActionTypes.UPDATE_ITEM, values, path, successCallback, errorCallback, submitHandler, showLoader };
}
export function deleteItem(path, successCallback, errorCallback, itemName) {
	return { type: ActionTypes.DELETE_ITEM, path, successCallback, errorCallback, itemName };
}
export function upsertFirebaseObject(objectType, id, object) {
	return { type: ActionTypes.UPSERT_FIREBASE_OBJECT, objectType, id, object };
}
